import { Component } from "../component"
import { Ajaxinate } from "ajaxinate"

export class InfiniteScroll extends Component {
  constructor(props) {
    super(props)
  }

  ui() {
    return {
      blogCardsContainer: "#AjaxinateContainer",
      pagination: "#AjaxinatePagination",
    }
  }

  setupInfiniteScroll() {
    const { blogCardsContainer, pagination } = this.ui()

    new Ajaxinate({
      container: blogCardsContainer,
      pagination: pagination,
      method: "scroll",
      loadingText: "Loading...",
    })
  }

  created() {
    this.setupInfiniteScroll()
  }
}
